import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, Tooltip } from '@mui/material';

import toast from 'features/toast';
import { useEffect, useState } from 'react';
import { IOption, IOptionFM } from 'interfaces';

import { fmTagService } from 'services/api/documents/FMTagService';
import { supplierService, warehouseService } from 'services/api';
import AddDocumentForm from './AddDocumentForm';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

interface IAddDocumentDialog {
  onSubmit: (values, suppliers) => void;
  currentFolder?: string;
  originalService?: string;
  objectId?: number;
  isFornitore?: boolean;
}

export const AddDocumentDialog = (params: IAddDocumentDialog) => {
  const { t } = useTranslation();

  const { onSubmit, currentFolder, objectId, originalService, isFornitore } = params;

  const [categorys, setCategorys] = useState<IOptionFM[]>([]);
  const [suppliers, setSuppliers] = useState<IOption[]>([]);
  const [warehouses, setWarehouses] = useState<IOption[]>([]);
  const [openDocumentDialog, setOpenDocumentDialog] = useState(false);

  // DIALOG functions management

  const handleCloseDocumentDialog = () => {
    setOpenDocumentDialog(false);
  };

  // TAGs management
  const startingUploadTags = () => {
    fmTagService.getAllPaginated(0, 0).then((response) => {
      setCategorys(response.results);
    });
    warehouseService.getAllBaseInformation().then(setWarehouses);
    supplierService.getAllBaseInformation().then((res) => {
      setSuppliers(
        res.map((value) => {
          return {
            id: value.id,
            code: `${value.code} - ${value.company_name}`,
            label: value.company_name
          };
        })
      );
    });
  };

  /**
   * Function to handle the submission of a new document.
   * Uploads the document to the API and refreshes the list of documents.
   *
   * @param {Object} values - The form values with the document details.
   */
  const onSubmitNewDocument = async (values) => {
    if (values.attachment == null || values.attachment == undefined) {
      toast.error(t('entities.document.empty-error'));
      return;
    }

    onSubmit(values, suppliers);

    // close document dialog
    setOpenDocumentDialog(false);
  };

  useEffect(() => {
    startingUploadTags();
  }, []);

  return (
    <>
      <Tooltip title={t('entities.document.file-upload')} arrow>
        <Button
          variant="contained"
          disabled={currentFolder && currentFolder !== '/'}
          onClick={() => setOpenDocumentDialog(true)}>
          <NoteAddIcon />
        </Button>
      </Tooltip>
      <Dialog open={openDocumentDialog} onClose={handleCloseDocumentDialog} fullWidth maxWidth="md">
        {/* Dialog for inserting new documents */}
        <div className="text-2xl p-5">{t('entities.document.title')}</div>
        <DialogContent>
          {/* Form for inserting new documents */}
          <AddDocumentForm
            onSubmit={onSubmitNewDocument}
            categorys={categorys}
            suppliers={isFornitore ? null : suppliers}
            warehouses={warehouses}
          />
        </DialogContent>
        <DialogActions>
          {/* Buttons for closing the dialog */}
          <Button onClick={handleCloseDocumentDialog} color="error">
            {t('actions.reset')}
          </Button>
          <Button type="submit" form="addNewDocument">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
